export default "__VITE_ASSET__MfSXXaD$__"